var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-alert-container"},_vm._l((_vm.alerts),function(alertData){return _c('alert',{key:alertData.index,attrs:{"alert":alertData}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }